/**
 * Paleta de marca LaPieza.
 * Alineada con `lib/theme/brandPalette.ts` de profile.lapieza.io y con
 * el sistema de color de lapieza.io (landing-front).
 *
 * Colores oficiales: #FFFFFF, #D40000, #DDDDDD, #2C3E50, #232323.
 */
export const brand = {
  white: "#FFFFFF",
  red: "#D40000",
  redHover: "#A00000",
  redLight: "#FF4444",
  gray: "#DDDDDD",
  navy: "#2C3E50",
  navyDark: "#1A2633",
  black: "#232323",
  textSecondary: "#555555",
  surfaceMuted: "#F7F8FA",
  /** Rojo aclarado: única variante con contraste suficiente sobre navy. */
  redOnDark: "#FF6B6B",
} as const;

export const fonts = {
  heading: `"Syne", "Urbanist", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif`,
  body: `"Urbanist", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif`,
} as const;

export const radii = {
  sm: "8px",
  md: "12px",
  lg: "16px",
  pill: "50px",
} as const;

export const palette = {
  ...brand,

  // ── Marca ────────────────────────────────────────────────────────────────
  primary: brand.red,
  primaryHover: brand.redHover,
  secondary: brand.navy,

  // ── Texto ────────────────────────────────────────────────────────────────
  textPrimary: brand.black,
  textSecondary: brand.textSecondary,
  textOnDark: brand.white,

  // ── Superficies y bordes ─────────────────────────────────────────────────
  surface: brand.white,
  surfaceMuted: brand.surfaceMuted,
  border: brand.gray,

  // ── Semánticos ───────────────────────────────────────────────────────────
  // La identidad LaPieza es monocroma + rojo: el estado positivo se comunica
  // en navy y el de error/alerta en rojo de marca.
  success: brand.navy,
  danger: brand.red,

  // ── Overlays y sombras ───────────────────────────────────────────────────
  overlayDark: "rgba(35, 35, 35, 0.55)",
  overlayLight: "rgba(35, 35, 35, 0.35)",
  overlayWhite: "rgba(255, 255, 255, 0.95)",
  shadowLight: "rgba(35, 35, 35, 0.08)",
  shadowMedium: "rgba(44, 62, 80, 0.14)",
  shadowDark: "rgba(44, 62, 80, 0.2)",
  shadowStrong: "rgba(35, 35, 35, 0.35)",
  redGlow: "rgba(212, 0, 0, 0.28)",
  redGlowSoft: "rgba(212, 0, 0, 0.18)",
  redGlowNone: "rgba(212, 0, 0, 0)",
  boxShadowCard: "0 2px 8px rgba(35, 35, 35, 0.06)",
  boxShadowCardHover: "0 10px 28px rgba(44, 62, 80, 0.12)",
};
